import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'
import _imports_1 from '../assets/images/register.png'


const _withScopeId = n => (_pushScopeId("data-v-a53a02dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "micolist"
}, null, -1))
const _hoisted_4 = { class: "search-box" }
const _hoisted_5 = ["onKeyup"]
const _hoisted_6 = { class: "categories" }
const _hoisted_7 = { class: "list-box" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "register" }
const _hoisted_10 = { class: "white-box" }
const _hoisted_11 = ["alt"]

import { onBeforeMount, ref } from "vue";
import { listCategories } from "@/services/portalService";
import { CategoryItem } from "@/models/Category";
import MenuNav from "@/components/MenuNav.vue";
import TheFooter from "@/components/TheFooter.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const categories = ref<CategoryItem[]>([]);
const searchWord = ref("");
const router = useRouter();

const sendSearch = () => {
  if (searchWord.value.length > 0) {
    router.push(`/search/${searchWord.value}`);
  }
};

const fetchData = async () => {
  categories.value = await listCategories();
};

onBeforeMount(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(MenuNav, { color: "gold" }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("home-page.search-title")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "search-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchWord).value = $event)),
            onKeyup: _withKeys(sendSearch, ["enter"])
          }, null, 40, _hoisted_5), [
            [_vModelText, searchWord.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("home-page.categories-title")), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
            return (_openBlock(), _createElementBlock("li", {
              key: cat.hid
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'category', params: { category: cat.slug } }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: cat.icon,
                    alt: cat.name
                  }, null, 8, _hoisted_8),
                  _createElementVNode("span", null, _toDisplayString(cat.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("home-page.register-title")), 1),
      _createVNode(_component_router_link, { to: "register" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: _ctx.$t('home-page.register-free')
            }, null, 8, _hoisted_11),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("home-page.register-free")), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(TheFooter)
  ], 64))
}
}

})